#import "../fragments/saved-filter-fragment.graphql"

query GetEmailMarketingSavedFilters($sort: SavedFilterSortType) {
    emailMarketingSavedFilters(sort: $sort) {
        ...SavedFilterFragment
    }
}
